module.exports = __webpack_public_path__ + "img/pic7.e87d6cc0.jpg";